import { useSelector } from "react-redux";
import { Users } from "../modules/Users";
import { AuthenticationState } from "../interfaces/users";
import { useMemo } from "react";
import { hasNoPermission } from "../utils/helpers/userHelpers";

export const UsersPage = () => {
  const { user } = useSelector((state: AuthenticationState) => state);
  const hasPermission = useMemo(() => hasNoPermission("users", user), [user]);
  return (
    <>
      {hasPermission ? (
        <Users />
      ) : (
        <div>O seu usuário não possui permissão para acessar este conteúdo</div>
      )}
    </>
  );
};
